import { FormControl, FormHelperText, FormLabel, Slider } from "@mui/material";
import { Controller, useWatch } from "react-hook-form";
import RightToLeftLayout from "../RightToLeft";

const SliderFieldRange = ({
  control,
  label = "",
  required = false,
  fullWidth = true,
  errorObject,
  className = "",
  disabled = false,
  min = 0,
  max = 100,
  step = 1,
  minName,
  maxName,
  valueLabelDisplay = "auto",
  sx = {},
}) => {
  const minValue = useWatch({ control, name: minName }) ?? min;
  const maxValue = useWatch({ control, name: maxName }) ?? max;

  const handleChange = ([newMin, newMax], onChangeMin, onChangeMax) => {
    onChangeMin(newMin);
    onChangeMax(newMax);
  };

  return (
    <RightToLeftLayout>
      <Controller
        name={minName}
        control={control}
        render={({ field: fieldMin }) => (
          <Controller
            name={maxName}
            control={control}
            render={({ field: fieldMax, fieldState: { error } }) => (
              <FormControl
                fullWidth={fullWidth}
                required={required}
                error={!!error}
                className={className}
                component="fieldset"
              >
                {label && (
                  <FormLabel
                    sx={{
                      mb: 1,
                      "& .MuiFormLabel-asterisk": {
                        color: disabled ? "gray" : "red",
                      },
                    }}
                  >
                    {label}
                  </FormLabel>
                )}

                <Slider
                  value={[minValue, maxValue]}
                  onChange={(e, newValue) =>
                    handleChange(newValue, fieldMin.onChange, fieldMax.onChange)
                  }
                  valueLabelDisplay={valueLabelDisplay}
                  disabled={disabled}
                  min={min}
                  max={max}
                  step={step}
                  sx={{
                    color: "var(--detail-application-radio-button)",
                    "& .MuiSlider-thumb::after": {
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: "var(--degree-item-list-document-box)",
                    },
                    "& .MuiSlider-rail": {
                      backgroundColor: "var(--slider-background)",
                    },
                    ...sx,
                  }}
                />

                {(error?.message || errorObject?.message) && (
                  <FormHelperText>{error?.message || errorObject?.message}</FormHelperText>
                )}
              </FormControl>
            )}
          />
        )}
      />
    </RightToLeftLayout>
  );
};

export default SliderFieldRange;
